<div class="container hide-mobile">
  <!-- FORM INPUTS -->
  <div class="row user-info-header is-flex">
    <div class="col s12">
      <div class="container mt-5">
        <div class="row">
          <div class="col s2"></div>
          <div class="col s6 mt-5">
            <!-- User Info -->
            <span>{{ loadedUser.email }}</span>
            <ng-container>
              <span> | </span>
              <span>Last refreshed on {{ currentTime | date : 'shortTime' }}</span
              >&nbsp;
            </ng-container>
          </div>
          <div class="col s2">
            <!-- Refresh -->
            <button #refreshBtn class="btn btn-link" name="refresh" type="button" (click)="refreshList()">
              <fa-icon icon="recycle"></fa-icon>&nbsp; Refresh
            </button>
          </div>
          <div class="col s2">
            <!-- Logout -->
            <button (click)="logout()" #refreshBtn class="btn btn-primary" name="logout" type="button">
              <fa-icon icon="lock"></fa-icon>&nbsp; Logout
            </button>
          </div>
          <!--          <div class="col s2"></div>-->
        </div>
      </div>
    </div>
  </div>
</div>
